var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TotalTableRow',{attrs:{"itemList":_vm.rows,"splitTotal":_vm.splitTotal,"embedded":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }